export default __webpack_public_path__ + "static/media/agustin4.0188f001.png";